import { render, staticRenderFns } from "./EC05AO_COOWNER.vue?vue&type=template&id=636b7ccd&"
import script from "./EC05AO_COOWNER.vue?vue&type=script&lang=js&"
export * from "./EC05AO_COOWNER.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports